export default "__VITE_ASSET__DKQnLsCH__"